module.exports = __webpack_public_path__ + "img/KK0039C-BL.a2561e3b.jpg";